// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DrugPairEffectPopover — centered modal for the Antidote / Toxicity pseudo
   equip-card nodes. Dark tactical surface; antidote green, toxicity orange. */

.dpe-scrim {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(3px);
  animation: dpe-fade 140ms ease;
}

@keyframes dpe-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dpe-panel {
  width: min(420px, 92vw);
  max-height: 82vh;
  overflow-y: auto;
  background: #14141a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.6);
  padding: 18px 18px 14px;
  animation: dpe-pop 150ms cubic-bezier(0.2, 0.8, 0.3, 1);
}

@keyframes dpe-pop {
  from { transform: scale(0.96); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* Accent stripe by kind */
.dpe-panel--antidote { border-top: 3px solid #22c55e; }
.dpe-panel--toxicity { border-top: 3px solid #fb923c; }

.dpe-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.dpe-head-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dpe-eyebrow {
  font-size: 0.56rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: rgba(255, 255, 255, 0.4);
}

.dpe-title {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}
.dpe-panel--antidote .dpe-title { color: #4ade80; }
.dpe-panel--toxicity .dpe-title { color: #fb923c; }

.dpe-total {
  font-size: 1.15rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.dpe-panel--antidote .dpe-total { color: #22c55e; }
.dpe-panel--toxicity .dpe-total { color: #fb923c; }
.dpe-total-unit {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.45);
}

.dpe-sub {
  margin: 10px 0 14px;
  font-size: 0.72rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.5);
}

.dpe-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dpe-row {
  padding: 9px 11px;
  border-radius: 9px;
  border-left: 2px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.02);
}
.dpe-panel--antidote .dpe-row {
  border-left-color: rgba(34, 197, 94, 0.7);
  background: rgba(34, 197, 94, 0.05);
}
.dpe-panel--toxicity .dpe-row {
  border-left-color: rgba(251, 146, 60, 0.7);
  background: rgba(251, 146, 60, 0.05);
}
.dpe-row--mask {
  border-left-color: rgba(245, 158, 11, 0.7) !important;
  background: rgba(245, 158, 11, 0.05) !important;
}

.dpe-row-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.dpe-drugs {
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: rgba(255, 255, 255, 0.9);
}

.dpe-delta {
  font-size: 0.82rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.dpe-panel--antidote .dpe-delta { color: #22c55e; }
.dpe-panel--toxicity .dpe-delta { color: #fb923c; }
.dpe-delta--mask {
  font-size: 0.58rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #f59e0b;
}

.dpe-name {
  margin-top: 3px;
  font-size: 0.74rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.72);
}

.dpe-mech {
  margin-top: 4px;
  font-size: 0.68rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.45);
}

.dpe-foot {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}

.dpe-close {
  padding: 7px 16px;
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  transition: background 140ms ease, border-color 140ms ease;
}
.dpe-close:hover {
  background: rgba(255, 255, 255, 0.09);
  border-color: rgba(255, 255, 255, 0.18);
}
`, "",{"version":3,"sources":["webpack://./src/components/SkillTreeViewport/DrugPairEffectPopover.css"],"names":[],"mappings":"AAAA;8EAC8E;;AAE9E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA,0BAA0B;AAC1B,uBAAuB,6BAA6B,EAAE;AACtD,uBAAuB,6BAA6B,EAAE;;AAEtD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;;AAElD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;AACvC;AACA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC","sourcesContent":["/* DrugPairEffectPopover — centered modal for the Antidote / Toxicity pseudo\n   equip-card nodes. Dark tactical surface; antidote green, toxicity orange. */\n\n.dpe-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 4000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.62);\n  backdrop-filter: blur(3px);\n  animation: dpe-fade 140ms ease;\n}\n\n@keyframes dpe-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.dpe-panel {\n  width: min(420px, 92vw);\n  max-height: 82vh;\n  overflow-y: auto;\n  background: #14141a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.6);\n  padding: 18px 18px 14px;\n  animation: dpe-pop 150ms cubic-bezier(0.2, 0.8, 0.3, 1);\n}\n\n@keyframes dpe-pop {\n  from { transform: scale(0.96); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n/* Accent stripe by kind */\n.dpe-panel--antidote { border-top: 3px solid #22c55e; }\n.dpe-panel--toxicity { border-top: 3px solid #fb923c; }\n\n.dpe-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.dpe-head-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.dpe-eyebrow {\n  font-size: 0.56rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.dpe-title {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n}\n.dpe-panel--antidote .dpe-title { color: #4ade80; }\n.dpe-panel--toxicity .dpe-title { color: #fb923c; }\n\n.dpe-total {\n  font-size: 1.15rem;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.dpe-panel--antidote .dpe-total { color: #22c55e; }\n.dpe-panel--toxicity .dpe-total { color: #fb923c; }\n.dpe-total-unit {\n  font-size: 0.6rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.dpe-sub {\n  margin: 10px 0 14px;\n  font-size: 0.72rem;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.dpe-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dpe-row {\n  padding: 9px 11px;\n  border-radius: 9px;\n  border-left: 2px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.02);\n}\n.dpe-panel--antidote .dpe-row {\n  border-left-color: rgba(34, 197, 94, 0.7);\n  background: rgba(34, 197, 94, 0.05);\n}\n.dpe-panel--toxicity .dpe-row {\n  border-left-color: rgba(251, 146, 60, 0.7);\n  background: rgba(251, 146, 60, 0.05);\n}\n.dpe-row--mask {\n  border-left-color: rgba(245, 158, 11, 0.7) !important;\n  background: rgba(245, 158, 11, 0.05) !important;\n}\n\n.dpe-row-top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.dpe-drugs {\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.dpe-delta {\n  font-size: 0.82rem;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.dpe-panel--antidote .dpe-delta { color: #22c55e; }\n.dpe-panel--toxicity .dpe-delta { color: #fb923c; }\n.dpe-delta--mask {\n  font-size: 0.58rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #f59e0b;\n}\n\n.dpe-name {\n  margin-top: 3px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.dpe-mech {\n  margin-top: 4px;\n  font-size: 0.68rem;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.dpe-foot {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.dpe-close {\n  padding: 7px 16px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.8);\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 140ms ease, border-color 140ms ease;\n}\n.dpe-close:hover {\n  background: rgba(255, 255, 255, 0.09);\n  border-color: rgba(255, 255, 255, 0.18);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
